import requestJWT from "utils/requestJWT";

const createTourOrderApi = async (data) => {
    return await requestJWT.post(`/tour-order/create`, data);
};

const getTourOrderApi = async (departureDay, status) => {
    return await requestJWT.get(`/tour-order/get-tour?departure=${departureDay}&status=${status}`);
};


const updateTourOrderApi = async (id, data) => {
    return await requestJWT.put(`/tour-order/${id}/update`, data);
};

const removeTourOrderApi = async (id) => {
    return await requestJWT.delete(`/tour-order/${id}/remove`);
};

const getTourOrderByAdminApi = async (status, query, page) => {
    return await requestJWT.get(`/tour-order/get-by-admin?status=${status}&query=${query}&page=${page}&item=5`);
};

const getTourOrderStatisticalApi = async (tourType, startDate, endDate, page, customer, staff) => {
    return await requestJWT.get(`/tour-order/statistical?tour_type=${tourType}&start_date=${startDate}&end_date=${endDate}&page=${page}&item=5&customer=${customer}&staff=${staff}`);
};


export {
    createTourOrderApi,
    getTourOrderApi,
    updateTourOrderApi,
    getTourOrderByAdminApi,
    removeTourOrderApi,
    getTourOrderStatisticalApi
};
